import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import {
  LANDING_FLEET_LOGIN_URL,
  LANDING_FREIGHT_LOGIN_URL,
} from '../landing-app-links';

interface HowItWorksStep {
  num: number;
  title: string;
  desc: string;
}

@Component({
  selector: 'app-marketplace-section',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './marketplace-section.html',
  styles: [`:host { display: block; }`],
})
export class MarketplaceSectionComponent {
  protected readonly freightLoginUrl = LANDING_FREIGHT_LOGIN_URL;
  protected readonly fleetLoginUrl = LANDING_FLEET_LOGIN_URL;

  shipperSteps: HowItWorksStep[] = [
    { num: 1, title: 'marketplace.shippers.step1.title', desc: 'marketplace.shippers.step1.desc' },
    { num: 2, title: 'marketplace.shippers.step2.title', desc: 'marketplace.shippers.step2.desc' },
    { num: 3, title: 'marketplace.shippers.step3.title', desc: 'marketplace.shippers.step3.desc' },
  ];

  carrierSteps: HowItWorksStep[] = [
    { num: 1, title: 'marketplace.carriers.step1.title', desc: 'marketplace.carriers.step1.desc' },
    { num: 2, title: 'marketplace.carriers.step2.title', desc: 'marketplace.carriers.step2.desc' },
    { num: 3, title: 'marketplace.carriers.step3.title', desc: 'marketplace.carriers.step3.desc' },
  ];

  marketplaceCaps: string[] = [
    'Multi-currency payments',
    'Port clearance support',
    'Mutual carrier & shipper ratings',
    'Live delivery timeline',
    'Google Maps routing',
    'Real-time notifications',
    'Pre & post-payment terms',
    'Load type & weight matching',
  ];
}
